// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@mui/material'

const StyledListItemButton = styled(ListItemButton)`
  height: 56px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 0 16px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.palette.neutral000};
  }
`

const StyledListItemIcon = styled(ListItemIcon)<{ 'data-bg-color'?: string }>`
  min-width: 32px;
  height: 32px;
  display: flex;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  margin-left: 12px;
  color: ${({ theme }) => theme.palette.neutral000};
  background-color: ${props =>
    props.theme.palette[props['data-bg-color'] as string] ||
    props.theme.palette.primary500};
`

const StyledSecondaryListItemText = styled(ListItemText)(() => ({
  flex: 'none',
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  Icon: JSX.Element
  onClick: () => any
  children: JSX.Element | string
  secondaryText?: number | string | null
  secondaryTextLoading?: boolean
  disabled?: boolean
  iconBgColor?: string
}

export function ChatProfileActionItem({
  Icon,
  onClick,
  children,
  secondaryText,
  secondaryTextLoading,
  disabled,
  iconBgColor,
}: Props) {
  return (
    <>
      <StyledListItem onClick={onClick} disabled={disabled}>
        <StyledListItemButton disableGutters>
          <StyledListItemIcon data-bg-color={iconBgColor}>
            {Icon}
          </StyledListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'subtitle2' }}>
            {children}
          </ListItemText>

          {secondaryTextLoading ? (
            <Skeleton sx={{ minWidth: '25px' }} />
          ) : secondaryText ? (
            <StyledSecondaryListItemText
              primaryTypographyProps={{
                variant: 'subtitle3',
                color: 'secondary.main',
              }}
            >
              {secondaryText}
            </StyledSecondaryListItemText>
          ) : null}
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}

ChatProfileActionItem.defaultProps = {
  secondaryText: null,
  secondaryTextLoading: false,
  disabled: false,
}
